import './variableLabel.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { FunctionOutlined } from '@ant-design/icons';

import { i18n } from 'core/localization';

import { formatVariableValue } from '../../utils/formatVariableValue';
import { VariableLabelProps } from './types';

const b = b_.with('variable-label');

export const VariableLabel = observer(({ variable }: VariableLabelProps) => (
	<span className={b({ unknown: variable == null })}>
		<FunctionOutlined className={b('icon')} />
		<span className={b('name')}>{variable?.name ?? i18n('Unknown variable')}</span>
		{variable && <span className={b('value')}>{formatVariableValue(variable.value)}</span>}
	</span>
));
